import { useEffect, useState } from "react";
import type { SeasonSummary } from "../../../shared/contracts/season.js";
import { listSeasons } from "../fgl/season-api.js";
import { ClubhouseSeason } from "./clubhouse-approved-cards.js";

export function ClubhouseSeasonSummary(props: {
  accountId: string;
  revision: string;
  onOpen(): void;
}): React.JSX.Element {
  const [season, setSeason] = useState<SeasonSummary | null>(null);
  useEffect(() => {
    let active = true;
    setSeason(null);
    void listSeasons()
      .then((result) => {
        if (active)
          setSeason(
            result.seasons.find((item) => item.state === "active") ??
              result.seasons[0] ??
              null,
          );
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [props.accountId, props.revision]);
  const members = season
    ? [...season.members].sort(
        (a, b) =>
          Number(b.accountId === props.accountId) -
          Number(a.accountId === props.accountId),
      )
    : [];
  const score = members
    .map(
      (member) =>
        `${member.displayName} ${season?.standings.find((row) => row.memberId === member.id)?.points ?? 0}`,
    )
    .join(" – ");
  return (
    <ClubhouseSeason
      title={season?.name}
      summary={
        season
          ? `${score} · ${season.confirmedCount}/${season.rules.targetCount} confirmed${season.provisional ? " · Results under review" : ""}`
          : undefined
      }
      onOpen={() => {
        props.onOpen();
        if (season) {
          const url = new URL(window.location.href);
          url.searchParams.set("season", season.id);
          window.history.replaceState(null, "", url);
        }
      }}
    />
  );
}
